import SanitizeHTML from "./sanitize";

export default SanitizeHTML;
